import {
    GET_SNOWFLAKE_CONFIGURATION,
    SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION,
    SET_SNOWFLAKE_USER_CREDENTIALS
} from 'app/lib/types/server';
import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('snowflakeConfiguration');
const type = createActionType('snowflakeConfiguration');

export const GET_SNOWFLAKE_CONFIGURATION_ACTION_TYPE = apiType(GET_SNOWFLAKE_CONFIGURATION);

export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_ACTION_TYPE = apiType(
    SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION
);

export const SET_SNOWFLAKE_USER_CREDENTIALS_ACTION_TYPE = apiType(SET_SNOWFLAKE_USER_CREDENTIALS);

export const TOGGLE_CONNECTION_STATUS_DIALOG = type('ToggleConnectionStatusDialog');
